import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { WorkspaceFormContext } from 'features/workspace/contexts/WorkspaceFormContext'
import { CommonForm } from './CommonForm'
import { useUpdateWorkspace } from './hooks/useUpdateWorkspace'
import { EditSchema, editSchema, editSchemaDefault } from './schemas/edit'

export const WorkspaceEditForm = (): JSX.Element => {
  const { formId, loading, setTouched, setValid, workspace } = useContext(WorkspaceFormContext)
  const { errors: apiErrors, update } = useUpdateWorkspace()

  if (!workspace) return <Loading />

  return (
    <Form<EditSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={editSchema}
      schemaDefaults={editSchemaDefault(workspace)}
    >
      {() => <CommonForm />}
    </Form>
  )
}
